<template>
  <svg
    class="crv-mpr-dracht crv-svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="6 5 22 22"
  >
    <path
      fill-rule="evenodd"
      d="M19.0919018,12.0532894 C19.0208559,11.9822369 18.9039739,11.9822369 18.832928,12.0532894 L18.0537147,12.8302839 C17.9826688,12.9013364 17.9826688,13.0182294 18.0537147,13.089282 L18.3103967,13.3436961 L12.7550646,18.8880898 C11.8658448,19.7751012 11.7214612,21.2259491 12.5396351,22.177137 C13.0117466,22.7272215 13.6740779,23.0022638 14.3364092,23 C14.9414453,23 15.5464815,22.7707699 16.007134,22.3100741 L21.6518465,16.6785836 L21.9085285,16.9329977 C21.9795744,17.0040503 22.0964564,17.0040503 22.1675023,16.9329977 L22.9467156,16.1560033 C23.0177615,16.0872427 23.0177615,15.9703498 22.9467156,15.8992972 L19.0919018,12.0532894 Z M19.2867051,17.5014184 L15.6885733,17.5014184 L19.0804428,14.1161065 L20.8795087,15.9107573 L19.2867051,17.5014184 Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrvMprDracht',
}
</script>